import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { colors } from "../../theme";
import Background from "./svg/banner-yellow.svg";

const useStyles = makeStyles((theme) => ({
  title: {
    padding: "45px 0",
    textAlign: "center",
    fontFamily: "Poppins",
    color: colors.BANNER_TEXT,
    fontSize: "32px",
  },
  image: {
    backgroundImage: `url(${Background})`,
    height: "140px",
    width: "100%",
  },
}));

export default function Banner({ title }: { title: string }) {
  const classes = useStyles();

  // The banner always has a full width, no matter the screen size.
  return (
    <Grid item xs={12}>
      <div className={classes.image}>
        <div className={classes.title}>{title}</div>
      </div>
    </Grid>
  );
}
